import type { AxiosResponse } from "axios";

import { deleteData, getData, postData, putData } from "@/apis/apiInstance";

import type {
  AddEditEmployeeExpensePayloadType,
  SingleEmployeeExpensePayloadType,
} from "@/commonTypes/expenseManagementTypes";

import { getCSRFToken } from "@/utils/commonFunctions";

// Raise Expense
export async function addEmployeeExpenseApi(
  data: AddEditEmployeeExpensePayloadType
): Promise<AxiosResponse> {
  const { token, ...finalData } = data;

  return await postData(
    `invoice-generation/expense-disbursement/expense/add`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function updateEmployeeExpenseApi(
  data: AddEditEmployeeExpensePayloadType
): Promise<AxiosResponse> {
  const { token, ...finalData } = data;

  return await putData(
    `invoice-generation/expense-disbursement/expense/update`,
    finalData,
    {
      headers: {
        "Content-Type": "application/json",
        "user-token": token,
        "x-csrf-token": getCSRFToken(),
      },
    }
  );
}

export async function getAllEmployeeExpensesApi(
  token: string
): Promise<AxiosResponse> {
  return await getData(`invoice-generation/expense-disbursement/expense/list`, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getSingleEmployeeExpenseApi(
  data: SingleEmployeeExpensePayloadType
): Promise<AxiosResponse> {
  const { token, disbursement_id } = data;

  return getData(`invoice-generation/expense-disbursement/expense/detail`, {
    params: disbursement_id,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function deleteEmployeeExpenseApi(
  data: SingleEmployeeExpensePayloadType
): Promise<AxiosResponse> {
  const { token, disbursement_id } = data;

  return deleteData(`invoice-generation/expense-disbursement/expense/delete`, {
    params: disbursement_id,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}
